import React from "react";
import { Link, Switch, Route } from "react-router-dom";
import AnnouncementShow from "./Details";
import AnnouncementPreview from "./Preview";
import {
  withContainers,
  ResizeContainer,
  NewsContainer,
  AcceleratorsContainer,
} from "../normalizer";
import "../../../assets/css/slider.scss";
import AcceleratorShow from "../Accelerators/AcceleratorShow";
import AcceleratorDetail from "../Accelerators/Details";

const Announcement = ({ news, imageSize, limitText, accelerators }) => {
  const previews = news.map((announcement) => {
    return (
      <div
        className="announcement-detail"
        key={"announcement-" + announcement.id}
      >
        <AnnouncementPreview
          announcement={announcement}
          imageSize={imageSize}
          limitText={limitText}
        />
      </div>
    );
  });

  return (
    <div className="announcements">
      <Switch>
        <Route exact path={"/news"}>
          <>
            <div className="announcements-preview-title">Notícias</div>
            <div className="announcements-preview-container">
              {previews}
              {accelerators != null && accelerators.length > 0 && (
                <>
                  {accelerators.map((accelerator) => (
                    <div key={accelerator.id} className="announcements-accelerators-container">
                      <Link
                        className="text-color gl-home__promotion"
                        to={`/news/${accelerator.id}`}
                      >
                        <AcceleratorShow
                          accelerator={accelerator}
                          limitText={limitText}
                          imageSize={imageSize}
                        />
                      </Link>
                    </div>
                  ))}
                </>
              )}
            </div>
          </>
        </Route>
        {news.map((element) => (
          <Route key={`route-${news.id}`} exact path={`/news/${element.id}`}>
            <AnnouncementShow imageSize={imageSize} announcement={element} />
          </Route>
        ))}
        {accelerators.map((accelerator) => (
          <Route
            exact
            key={`route-${accelerator.id}`}
            path={`/news/${accelerator.id}`}
          >
            <AcceleratorDetail
              accelerator={accelerator}
              limitText={limitText}
              imageSize={imageSize}
            />
          </Route>
        ))}
      </Switch>
    </div>
  );
};

export default withContainers(Announcement, [
  NewsContainer,
  AcceleratorsContainer,
  ResizeContainer,
]);
